import type { ReactNode } from 'react'
import React, { forwardRef } from 'react'

import { Skeleton } from '@fourthwall/components'

import * as S from './ChartContainer.styled'

type ChartContainerProps = {
  isEmpty: boolean
  emptyMessage?: string
  isLoading: boolean
  children?: ReactNode
}

export const ChartContainer = forwardRef<HTMLDivElement, ChartContainerProps>(
  ({ isEmpty, emptyMessage = 'No data', isLoading, children }, ref) => {
    if (isLoading) {
      return (
        <S.Container>
          <Skeleton.Shape width="100%" height="100%" />
        </S.Container>
      )
    }

    if (isEmpty) {
      return (
        <S.Container>
          <S.EmptyMessage>{emptyMessage}</S.EmptyMessage>
        </S.Container>
      )
    }

    return (
      <S.Container>
        <S.Chart ref={ref}>{children}</S.Chart>
      </S.Container>
    )
  },
)
